// extracted by mini-css-extract-plugin
export default {"form":"ProductForm_form__QOloH","currency":"ProductForm_currency__DE-l1"};